// #region Dependencias
import styled from 'styled-components'
import { InputLabel } from 'components/Library'
import { colors } from 'components/Library/theme'
// #endregion

// #region Estilos
export const StyledInputContainer = styled.div`
  margin-bottom: 0.5rem;
  min-width: 120px;
  width: 100%;
`

const StyledInput = styled.input`
  appearance: none;
  background-color: transparent;
  border-radius: 2rem;
  outline: none;
  border: 2px solid ${colors.primary};
  height: 15px;
  width: 100%;

  &::-webkit-slider-thumb {
    appearance: none;
    width: 25px;
    height: 25px;
    background: ${colors.primary};
    border-radius: 1rem;
    cursor: pointer;
  }
`
// #endregion

/**
 * Componente para renderizar un <input /> de selección de rango.
 *
 * @class
 * @example
 * <InputRange label="Edad" name="edad" min={1} max={100} step={1} value={50} onChange={handleInputChange} />
 *
 * @param {Object} props - Propiedades del componente.
 * @param {string} [props.className=null] - Clase CSS para aplicar al campo.
 * @param {string} props.label - Texto de la etiqueta del campo.
 * @param {number} props.min - Rango mínimo del componente.
 * @param {number} props.max - Rango máximo del componente.
 * @param {number} props.step - Intervalo por movimiento del componente.
 * @param {string} props.name - Nombre del campo, utilizado como valor del atributo 'htmlFor' de la etiqueta.
 * @param {string} props.value - Valor actual del campo.
 * @param {React.ReactNode} props.children - Contenido que será renderizado dentro del componente.
 * @param {Function} onChange - Callback que se ejecuta al modificar el valor del campo.
 */
const InputRange = ({ className, label, name, type = 'text', value, children, ...props }) => {
  return (
    <StyledInputContainer>
      <InputLabel htmlFor={name} label={`${label}: ${value}`} value={value} />
      <StyledInput name={name} type="range" value={value} {...props}>
        {children}
      </StyledInput>
    </StyledInputContainer>
  )
}

export default InputRange
